import React from 'react';
import { get } from 'lodash';

import { Link } from 'libs/router';

import MediaPreview from 'components/MediaPreview';

import SystemMessage from './SystemMessage';

import { getSystemMessageContentLinkForBrand } from 'utils/messenger';
import { __t, applyTranslations } from 'utils/language';

import type {
  Campaign,
  DeliverablesFilterCampaign,
  MediaPreviewAttachment,
  Subcampaign
} from 'types';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  metadata: {
    postType: DeliverablesFilterCampaign,
    subcampaign: Subcampaign,
    subcampaignPostAttachment: MediaPreviewAttachment
  },
  text: string,
  isBrand: boolean,
  campaign: Campaign
};

class SystemChatMessagePostAttachmentAdded extends SystemMessage<Props> {
  renderBrandLink(campaign, subcampaignId) {
    const { metadata } = this.props;
    const deliverableId = get(metadata, 'deliverable.id', null);
    const isCcm = campaign.campaignType === 'ccm';
    const link = getSystemMessageContentLinkForBrand(campaign.id, subcampaignId, deliverableId, metadata.postType || 'all', null, isCcm);

    return (
      <span>
        <Link
          to={link}
          className="system-chat-message__link system-chat-message__link--post"
        >
          {__t('system_message.deliverables_open')}
        </Link>
      </span>
    );
  }

  render() {
    const { metadata, text, isBrand, campaign } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon()}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-post-attachment__bubble"
          >
            <div>
              {text}
              {
                isBrand &&
                  this.renderBrandLink(campaign, metadata.subcampaign.id)
              }
              {
                metadata.subcampaignPostAttachment &&
                  <div>
                    <MediaPreview
                      className="system-chat-message__media"
                      attachment={metadata.subcampaignPostAttachment}
                      width={200}
                      height={200}
                    />
                  </div>
              }
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessagePostAttachmentAdded;
